import { Link } from "wouter";
import { useTranslation } from "react-i18next";
import { Instagram, Phone, MessageCircle } from "lucide-react";
const logoImg = "/housekeeping-logo-dark.png";

export function Footer() {
  const { t } = useTranslation();

  const quickLinks = [
    { href: "/", label: t("nav.home") },
    { href: "/booking", label: t("nav.booking") },
    { href: "/about", label: t("nav.about") },
    { href: "/orders", label: t("nav.orders") },
    { href: "https://wa.me/96551470470", label: t("footer.contact"), external: true },
  ];

  const contacts = [
    {
      icon: <Phone className="w-4 h-4" />,
      label: "+965 51 470 470",
      href: "tel:+96551470470",
      ltr: true,
    },
    {
      icon: <MessageCircle className="w-4 h-4" />,
      label: t("footer.connect"),
      href: "https://wa.me/96551470470",
      external: true,
    },
    {
      icon: <Instagram className="w-4 h-4" />,
      label: "Thehousekeepingkw",
      href: "https://www.instagram.com/Thehousekeepingkw/",
      external: true,
    },
  ];

  return (
    <footer className="bg-[hsl(217,54%,18%)] text-slate-300 py-14">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-10 mb-10">

          {/* Brand column */}
          <div>
            <Link href="/" className="flex items-center gap-3 mb-5">
              <img
                src={logoImg}
                alt="The Housekeeping Logo"
                className="h-12 w-12 object-contain flex-shrink-0"
              />
              <div className="flex flex-col leading-none text-white">
                <span className="text-xs font-bold uppercase tracking-widest">
                  CLEANING SOLUTIONS
                </span>
                <span className="text-[10px] uppercase tracking-wider text-slate-400 mt-0.5 font-medium">
                  THE HOUSEKEEPING
                </span>
              </div>
            </Link>
            <p className="text-sm leading-relaxed opacity-80">
              {t("footer.description")}
            </p>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="font-bold text-white mb-5 text-sm uppercase tracking-wide">
              {t("footer.quickLinks")}
            </h4>
            <ul className="space-y-2.5 text-sm">
              {quickLinks.map((link, i) =>
                link.external ? (
                  <li key={i}>
                    <a
                      href={link.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:text-secondary transition-colors"
                    >
                      {link.label}
                    </a>
                  </li>
                ) : (
                  <li key={i}>
                    <Link href={link.href} className="hover:text-secondary transition-colors">
                      {link.label}
                    </Link>
                  </li>
                )
              )}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-bold text-white mb-5 text-sm uppercase tracking-wide">
              {t("footer.contact")}
            </h4>
            <ul className="space-y-3">
              {contacts.map((item, i) => (
                <li key={i}>
                  <a
                    href={item.href}
                    target={item.external ? "_blank" : undefined}
                    rel={item.external ? "noopener noreferrer" : undefined}
                    className="flex items-center gap-3 text-sm hover:text-secondary transition-colors group"
                    data-testid={`footer-contact-${i}`}
                  >
                    <div className="w-8 h-8 rounded-full bg-[hsl(217,54%,24%)] flex items-center justify-center flex-shrink-0 group-hover:bg-secondary transition-colors">
                      {item.icon}
                    </div>
                    <span dir={item.ltr ? "ltr" : undefined}>{item.label}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-[hsl(217,54%,28%)] pt-7 text-center text-xs opacity-50">
          © {new Date().getFullYear()} The Housekeeping. {t("footer.rights")}
        </div>
      </div>
    </footer>
  );
}
